module.exports = __webpack_public_path__ + "img/so.e5481e80.svg";